import { render, staticRenderFns } from "./AppletAuthentication.vue?vue&type=template&id=165a8fa0&scoped=true&"
import script from "./AppletAuthentication.vue?vue&type=script&lang=js&"
export * from "./AppletAuthentication.vue?vue&type=script&lang=js&"
import style0 from "./AppletAuthentication.vue?vue&type=style&index=0&id=165a8fa0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165a8fa0",
  null
  
)

export default component.exports